import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  };

  const role = user && user.role;
  const can = {
    admin: role === "admin",
    manage: role === "admin" || role === "pm" || role === "labor_manager",
    field: role === "admin",
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, can, role }}>
      {children}
    </AuthContext.Provider>
  );
}
